/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HouseNumberType } from './houseNumberType.model';


export interface ContactAddressDto { 
    castObce?: string;
    cisloDomovni?: number;
    cisloOrientacni?: string;
    cpCe?: HouseNumberType;
    mestskaCast?: string;
    obec?: string;
    okres?: string;
    paymentAddress: boolean;
    psc?: string;
    stat?: string;
    ulice?: string;
}
export namespace ContactAddressDto {
}


